"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Avatar = _interopRequireDefault(require("@material-ui/core/Avatar"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _Menu = _interopRequireDefault(require("@material-ui/core/Menu"));
var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));
var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));
var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));
var _EditOutlined = _interopRequireDefault(require("@material-ui/icons/EditOutlined"));
var _AccountCircleOutlined = _interopRequireDefault(require("@material-ui/icons/AccountCircleOutlined"));
var _materialUiPopupState = _interopRequireWildcard(require("material-ui-popup-state"));
var _axios = _interopRequireDefault(require("axios"));
var _cache = require("@stt-componentes/cache");
var _SttHeading = _interopRequireDefault(require("../../SttTypography/SttHeading"));
var _excluded = ["config", "nomeUsuario", "strings", "headers"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    boxMenuUsuario: {
      display: 'flex',
      flexFlow: 'column wrap',
      alignItems: 'center',
      padding: 0,
      spacing: 0,
      height: '264px',
      width: '232px'
    },
    avatar: {
      width: 20,
      height: 20,
      border: '1px solid gray'
    },
    nome: {
      color: '#828282',
      fontSize: '0.85rem',
      fontWeight: '400'
    },
    nomeUsuario: {
      color: theme.palette.text.primary,
      fontSize: '0.85rem',
      fontWeight: '400',
      textAlign: 'left',
      margin: '0 auto',
      marginLeft: theme.spacing(0.5)
    }
  };
});
var SttMenuUsuario = function SttMenuUsuario(_ref) {
  var config = _ref.config,
    nomeUsuario = _ref.nomeUsuario,
    strings = _ref.strings,
    headers = _ref.headers,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    imageSrc = _useState2[0],
    setImageSrc = _useState2[1];
  (0, _react.useEffect)(function () {
    var userInfo = _cache.Cache.getUserInfo();
    if (userInfo !== null && userInfo !== void 0 && userInfo.foto) {
      _axios["default"].get("".concat(config.url_base_api_oauth2, "/interno/user-image"), {
        headers: headers,
        responseType: 'blob'
      }).then(function (response) {
        if (response.data) {
          var blob = response.data;
          var fileURL = URL.createObjectURL(blob);
          setImageSrc(fileURL);
        }
      })["catch"](function (err) {
        console.log(err);
      });
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      marginLeft: '12px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_materialUiPopupState["default"], {
    variant: "popover"
  }, function (popupState) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], _extends({
      disableRipple: true,
      size: "small"
    }, props, (0, _materialUiPopupState.bindTrigger)(popupState)), imageSrc ? /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
      src: imageSrc,
      className: classes.avatar
    }) : /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
      className: classes.avatar,
      style: {
        backgroundColor: '#075891',
        fontSize: '0.8rem'
      }
    }, (nomeUsuario || '').charAt(0).toUpperCase())), /*#__PURE__*/_react["default"].createElement(_Menu["default"], (0, _materialUiPopupState.bindMenu)(popupState), /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
      onClick: function onClick() {
        popupState.close();
        var eventbus = {
          "acao": "REDIRECT_MEUS_DADOS"
        };
        window.parent.postMessage(eventbus, "*");
      }
    }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], null, /*#__PURE__*/_react["default"].createElement(_AccountCircleOutlined["default"], null)), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], null, strings.meusDados)), /*#__PURE__*/_react["default"].createElement(_Divider["default"], null), /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
      onClick: function onClick() {
        popupState.close();
        var eventbus = {
          "acao": "REDIRECT_INICIO"
        };
        window.parent.postMessage(eventbus, "*");
      }
    }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], null, /*#__PURE__*/_react["default"].createElement(_EditOutlined["default"], null)), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], null, strings.editarPerfil))));
  }), /*#__PURE__*/_react["default"].createElement(_SttHeading["default"], {
    variant: "h4",
    className: classes.nomeUsuario
  }, nomeUsuario));
};
var _default = SttMenuUsuario;
exports["default"] = _default;